module.exports = __webpack_public_path__ + "img/data_enginer.fa513fbd.jpg";